const locale = "it-IT";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm",
	"serviceReports.headline": "Report di assistenza",
	"serviceReports.sublineMachine": "Visualizzate i report di assistenza della vostra macchina e scaricateli.",
	"serviceReports.technicianName": "Nome tecnico",
	"serviceReports.machineNameAndNumber": "Macchina e n. macchina",
	"serviceReports.startDate": "Da",
	"serviceReports.endDate": "A",
	"serviceReports.creationDate": "Data creazione",
	"serviceReports.openReport": "Apri report di assistenza (PDF)",
	"serviceReports.filter": "Filtro",
	"serviceReports.missionNumber": "Numero di missione",
	"serviceReports.assignmentType": "Tipo report di assistenza",
	"serviceReports.reportTypes.IA": "Rapporto disinstallazione / rilocazione",
	"serviceReports.reportTypes.AC": "Rapporto consulenza applicativa",
	"serviceReports.reportTypes.IV": "Rapporto preparativi per l'installazione",
	"serviceReports.reportTypes.BA": "Rapporto perizia",
	"serviceReports.reportTypes.UV": "Rapporto ispezione di sicurezza",
	"serviceReports.reportTypes.IG": "Rapporto installazione macchina posseduta in precedenza",
	"serviceReports.reportTypes.UB": "Rapporto per misurazione qualità",
	"serviceReports.reportTypes.PN": "Rapporto assistenza alla produzione",
	"serviceReports.reportTypes.NR": "Rapporto retrofit",
	"serviceReports.reportTypes.IB": "Installazione/report start-up",
	"serviceReports.reportTypes.II": "Rapporto integrazione dell'installazione",
	"serviceReports.reportTypes.IC": "Rapporto riparazione interna",
	"serviceReports.reportTypes.MB": "Rapporto servizio allestimenti fieristici",
	"serviceReports.reportTypes.HW": "Rapporto risorsa",
	"serviceReports.reportTypes.TT": "Rapporto formazione tecnici",
	"serviceReports.reportTypes.SK": "Rapporto formazione clienti",
	"serviceReports.reportTypes.RP": "Rapporto di riparazione",
	"serviceReports.reportTypes.RW": "Rapporto di riparazione e manutenzione",
	"serviceReports.reportTypes.WA": "Rapporto di manutenzione",
	"serviceReports.reportTypesPlural.IA": "Rapporti disinstallazione / rilocazione",
	"serviceReports.reportTypesPlural.AC": "Rapporti consulenza applicativa",
	"serviceReports.reportTypesPlural.IV": "Rapporti preparativi per l'installazione",
	"serviceReports.reportTypesPlural.BA": "Rapporti perizie",
	"serviceReports.reportTypesPlural.UV": "Rapporti ispezioni di sicurezza",
	"serviceReports.reportTypesPlural.IG": "Rapporti installazione macchina posseduta in precedenza",
	"serviceReports.reportTypesPlural.UB": "Rapporti misurazione qualità",
	"serviceReports.reportTypesPlural.PN": "Rapporti assistenza alla produzione",
	"serviceReports.reportTypesPlural.NR": "Rapporti retrofit",
	"serviceReports.reportTypesPlural.IB": "Installazione/report start-up",
	"serviceReports.reportTypesPlural.II": "Rapporti integrazione dell'installazione",
	"serviceReports.reportTypesPlural.IC": "Rapporti riparazione interna",
	"serviceReports.reportTypesPlural.MB": "Rapporti servizio allestimenti fieristici",
	"serviceReports.reportTypesPlural.HW": "Rapporti risorse",
	"serviceReports.reportTypesPlural.TT": "Rapporti formazione tecnici",
	"serviceReports.reportTypesPlural.SK": "Rapporti formazione clienti",
	"serviceReports.reportTypesPlural.RP": "Rapporti di riparazione",
	"serviceReports.reportTypesPlural.RW": "Rapporti di riparazione e manutenzione",
	"serviceReports.reportTypesPlural.WA": "Rapporti di manutenzione",
	"serviceReports.loadMore": "Carica altro",
	"serviceReports.loadError": "Si è verificato un errore nel caricamento dei dati",
	"serviceReports.noReportsFound": "Al momento non sono presenti report di assistenza.",
	"serviceReports.noReportsAvailable": "Al momento non sono presenti report di assistenza.",
	missingAuthorization: "Autorizzazione mancante",
	"headline.createCase": "Creazione di una nuova pratica di assistenza",
	"headline.caseDetails": "Dettagli pratica",
	"headline.contactData": "Dati di contatto",
	"field.reason.label": "Causa messaggio",
	"field.machine.label": "Macchina e n. macchina",
	"field.softwareProblemClassification.label": "Classificazione del problema",
	"field.softwareInstallationProblem.label": "Problema di installazione",
	"field.softwareLicenseIssue.label": "Problema di licenza",
	"field.softwareType.label": "Tipo software",
	"field.softwareModule.label": "Modulo software",
	"field.errorNumber.label": "Numeri errore",
	"field.errorNumber.explanation": "ad es. 0000FC00, 1.10.58102409 o 6000",
	"field.errorNumber.addAnotherNumber": "aggiungi altri numeri errore",
	"field.errorNumber.errorMessage": "Numero errore non valido",
	"field.message.label": "Messaggio",
	"field.message.placeholder": "Descrivi (senza usare formule di saluto) il più concretamente possibile e in modo dettagliato la tua preoccupazione o il tuo problema. Grazie.",
	"field.fileUpload.label": "Allegati",
	"field.fileUpload.info": "Formati file consentiti: IMG, JPG, PNG, PDF, HTML, file TruTops ecc. (max. 16 MB) e file video MP4 (max. 50 MB)",
	"field.salutation.label": "Titolo",
	"field.salutation.male": "Sig.",
	"field.salutation.female": "Sig.ra",
	"field.firstName.label": "Nome",
	"field.lastName.label": "Cognome",
	"field.email.label": "E-mail",
	"field.phone.label": "Numero di telefono",
	"button.submit": "Invia",
	"button.cancel": "Annulla",
	"button.back": "indietro",
	"button.next": "avanti",
	"button.close": "Chiudi",
	"button.ok": "Ok",
	"auth.error": "Si è verificato un errore imprevisto.",
	"select.placeholder": "Selezionare ...",
	"validation.requiredField": "Questo campo è obbligatorio.",
	"validation.invalidEmail": "Immettere un indirizzo e-mail valido",
	"validation.maxAllowedCharacters": "Numero massimo consentito di caratteri: {{number}}",
	"validation.requiredFieldsExplanation": "I campi obbligatori sono contrassegnati da un *.",
	"validation.invalidPhoneNumber": "Immettere un numero di telefono valido.",
	"softwareProblemClassification.standstill": "Inattività",
	"softwareProblemClassification.fault": "Guasto",
	"softwareProblemClassification.slightImpairment": "Compromissione lieve",
	"softwareProblemClassification.generalInquiry": "Richiesta generale",
	"serviceCase.proactiveCaseClosure.title": "Feedback e richiesta di chiusura della pratica",
	"serviceCase.proactiveCaseClosure.instructions": "Al fine di richiedere la chiusura della pratica e aiutarci a migliorare il nostro Predictive Service, invitiamo gentilmente a inviare un feedback.",
	"serviceCase.proactiveCaseClosure.question.submit": "Invia",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Chiusura della pratica richiesta. Grazie per il feedback.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "L'anomalia segnalata era presente sulla macchina?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "È stata predisposta una guida tecnica?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "È stato possibile risolvere autonomamente il problema con l'ausilio delle guide tecniche?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Si desidera mettere in pausa le notifiche per questo tipo di anomalie?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Per quanto tempo si desidera mettere in pausa le notifiche per questo tipo di anomalie?",
	"serviceCase.proactiveCaseClosure.question.comment": "Spiegare i motivi per cui mettere in pausa le notifiche per questo tipo di anomalie:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Commento obbligatorio per richiedere la chiusura della pratica e inviare il feedback",
	"serviceCase.proactiveCaseClosure.answers.yes": "Sì",
	"serviceCase.proactiveCaseClosure.answers.no": "No",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 giorni",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 giorni",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 giorni",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 giorni",
	"sisConnector.success.headline": "Creazione della pratica di assistenza riuscita.",
	"sisConnector.success.orderNumberRequired.title": "Avviso:",
	"sisConnector.success.orderNumberRequired.text": "Aggiungere nella pagina dei dettagli pratica un numero d'ordine per la fatturazione della pratica e ulteriori servizi.",
	"sisConnector.success.technicalGuide.title": "Per questo/i numero/i errore è disponibile una guida tecnica.",
	"sisConnector.success.technicalGuide.text": "Sulla base del/i numero/i errore immesso/i è stato possibile individuare una o più guide tecniche. In circa il 50% dei casi, sei ora in grado di risolvere il problema in autonomia. Questa funzione è disponibile solo con un contratto di assistenza corrispondente.",
	"sisConnector.success.outsideOfServiceHours": "Si ricorda che le pratiche create al di fuori degli orari di servizio dell'assistenza tecnica non vengono elaborate.",
	"sisConnector.success.serviceTimes.MonFri": "Orari dell'assistenza tecnica: da lunedì a venerdì",
	"sisConnector.success.serviceTimes.Sat": "e sabato",
	"sisConnector.success.withTechnicalServiceHotline": "Per assistenza immediata, contattare telefonicamente l'assistenza tecnica di TRUMPF ({{hotline}}).",
	"sisConnector.success.withoutTechnicalServiceHotline": "Per assistenza immediata, contattare telefonicamente l'assistenza tecnica di TRUMPF.",
	"sisConnector.success.caseId": "Numero pratica",
	"sisConnector.failed.headline": "Non è stato possibile creare la pratica di assistenza.",
	"sisConnector.failed.unknownError": "Riprovare o rivolgersi all'assistenza di zona."
};
var itIT = {
	locale: locale,
	translations: translations
};

export { itIT as default, locale, translations };
//# sourceMappingURL=it-IT-ZZxSjxe3.js.map

//# sourceMappingURL=it-IT-ZZxSjxe3.js.map